import * as React from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import { Checkbox, IconButton, Tooltip } from '@mui/material';
import { MoreVertOutlined, ViewColumnOutlined } from '@mui/icons-material';
import { Connect, mapDispatchToProps, mapStateToProps } from '../../Redux';
interface Props {
    columns: { label: string, name: string }[]
    tablesColumnsFilters?: any
    columnsFilter?: string
    setRedux?: (data: any) => void
}
const ColumnsFilter: React.FC<Props> = ({
    columns,
    columnsFilter,
    tablesColumnsFilters,
    setRedux
}) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }
        setOpen(false);
    };

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <Stack direction="row" spacing={2}>
            <div style={{ zIndex: 10 }}>
                <Tooltip title={'View Columns'}>
                    <IconButton
                        ref={anchorRef}
                        id="composition-button"
                        aria-controls={open ? 'composition-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                    >
                        <ViewColumnOutlined />
                    </IconButton>
                </Tooltip>
                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-start"
                    transition
                    disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener
                                    onClickAway={handleClose}
                                >
                                    <MenuList
                                        autoFocusItem={open}
                                        id="composition-menu"
                                        aria-labelledby="composition-button"
                                        onKeyDown={handleListKeyDown}
                                    >
                                        {
                                            (columns.filter(q=>!(q.name === 'action'))).map(({ label, name }, i) => (
                                                <MenuItem sx={{
                                                    mt: 1
                                                }} key={label}
                                                    onClick={(e) => {
                                                        const currentFilter = tablesColumnsFilters[columnsFilter as string] || []
                                                        const isIncluded = currentFilter.includes(name)
                                                        let newFilter = isIncluded ? currentFilter.filter((q: string) => q !== name) : [...currentFilter, name]
                                                        if (setRedux)
                                                            setRedux({
                                                                tablesColumnsFilters: {
                                                                    ...tablesColumnsFilters,
                                                                    [columnsFilter as string]: newFilter
                                                                }
                                                            })
                                                    }
                                                    }>
                                                    <Checkbox
                                                        checked={(tablesColumnsFilters[columnsFilter as string] || []).includes(name)}
                                                    />
                                                    <span style={{ paddingLeft: 10 }}></span>{label}
                                                </MenuItem>
                                            ))
                                        }
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </Stack>
    );
}
export default Connect(mapStateToProps, mapDispatchToProps)(ColumnsFilter)